import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "../api/axios";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Password } from "primereact/password";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";
import { Accordion, AccordionTab } from "primereact/accordion";
import { ca } from "date-fns/locale";

const crearModuloPorTipo = (nombre) => {
  switch (nombre) {
    case "SUA":
      return {
        nombre: "SUA",
        activo: true,
        Empresas: [
          {
            rfc: "",
            nombre: "",
            registrosPatronales: [],
          },
        ],
        cntEmpresas: 0,
        cntRegistrosPatronales: 0,
      };

    case "NOM":
      return {
        nombre: "NOM",
        activo: true,
        Nominas: "",
      };

    case "CFDI":
      return {
        nombre: "CFDI",
        activo: true,
        Emisores: [],
      };

    case "XCS":
      return {
        nombre: "XCS",
        activo: true,
        Emisores: [],
      };

    case "IMSS":
      return {
        nombre: "IMSS",
        activo: true,
        archivoAltas: null,
        archivoBajas: null,
      };
    case "C4-Nic":
      return {
        nombre: "C4-Nic",
 activo: true,
        id: 0,
        NombreCliente: "",
        RUC: "",
        Regimen: "",
      };

    default:
      return {
        nombre,
        activo: true,
      };
  }
};
function TablaUsuarios(Authentication) {
  const emptyUsuario = {
    _id: null,
    nombre: "",
    email: "",
    password: "",
    refreshToken: "",
    roles: { User: 2001 },
    Modulos: [
      {
        nombre: "SUA",
        activo: false,
        Empresas: [
          {
            rfc: "",
            nombre: "",
            registrosPatronales: [],
          },
        ],
        cntEmpresas: 0,
        cntRegistrosPatronales: 0,
      },
      {
        nombre: "NOM",
        activo: false,
        Nominas: "",
      },
      {
        nombre: "C4-Nic",
        activo: false,
        NombreCliente: "",
        RUC: "",
        Regimen: "",
      },
    ],
  };

  const [usuarios, setUsuarios] = useState(null);
  const [newUsuarioDialog, setNewUsuarioDialog] = useState(false);
  const [editUsuarioDialog, setEditUsuarioDialog] = useState(false);
  const [modulosDialog, setModulosDialog] = useState(false);
  const [usuario, setUsuario] = useState(emptyUsuario);
  const [selectedEmpresas, setSelectedEmpresas] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const axiosPrivate = useAxiosPrivate();
  const GetUsuarios = async () => {
    await axiosPrivate.get("/admin/users").then((response) => {
      const data = response.data;
      console.log(data);
      setUsuarios(data);
    });
  };

  useEffect(() => {
    GetUsuarios();
  }, []);

  const openNew = () => {
    setUsuario(emptyUsuario);
    setSubmitted(false);
    setNewUsuarioDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setNewUsuarioDialog(false);
  };

  const hideDialogEdit = () => {
    setSubmitted(false);
    setEditUsuarioDialog(false);
  };

  const hideDialogModulos = () => {
    setSubmitted(false);
    setModulosDialog(false);
  };

  const saveUsuario = async () => {
    setSubmitted(true);
    console.log("saveUsuario", usuario);

    try {
      if (!usuario._id) {
        //nuevo usuario
        const response = await axios.post(
          "admin/users/new",
          JSON.stringify({ usuario }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        console.log(response.data);
        //setNewUsuarioDialog(false);
        //setUsuario(emptyUsuario);

        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: response.data.success,
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error al actualizar la empresa:", error.message);
    }
  };

  const SubmitEditUsuario = async () => {
    setSubmitted(true);
    console.log("editUsuario", usuario);
    try {
      if (usuario._id) {
        const response = await axios.put(
          "admin/users/update",
          JSON.stringify({ usuario }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        console.log(response.data);
        GetUsuarios();
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: response.data.success,
          life: 3000,
        });
        setEditUsuarioDialog(false);
        setUsuario(emptyUsuario);
      }
    } catch (error) {
      console.error("Error al actualizar la empresa:", error.message);
    }
  };
  const SubmitModulosUsuario = async () => {
    setSubmitted(true);
  
    // Reconstruimos TODOS los módulos, activos e inactivos
    const modulosParaEnviar = usuario.Modulos.map((modulo) => {
      const base = { nombre: modulo.nombre, activo: modulo.activo };
  
      switch (modulo.nombre) {
        case "SUA":
          return {
            ...base,
            Empresas: modulo.Empresas ?? [],
            cntEmpresas: modulo.cntEmpresas ?? 0,
            cntRegistrosPatronales: modulo.cntRegistrosPatronales ?? 0,
          };
        case "NOM":
          return {
            ...base,
            Nominas: modulo.Nominas ?? "",
          };
        case "CFDI":
          return {
            ...base,
            Emisores: modulo.Emisores ?? [],
          };
        case "IMSS":
          return {
            ...base,
            archivoAltas: modulo.archivoAltas ?? null,
            archivoBajas: modulo.archivoBajas ?? null,
          };
          case "C4-Nic":

          console.log("C4-Nic Modulo:", modulo);
          return {
            ...base,
            NombreCliente: modulo.NombreCliente ?? null,
            RUC: modulo.RUC ?? null,
            Regimen: modulo.Regimen ?? null,
            // archivoBajas: modulo.archivoBajas ?? null,
          };
        default:
          return base;
      }
    });
  
    const usuarioParaEnviar = {
      ...usuario,
      Modulos: modulosParaEnviar,
    };
  
    console.log("Enviando módulos:", usuarioParaEnviar.Modulos);
  
    try {
      if (usuario._id) {
        const response = await axios.put(
          "admin/users/modules/edit",
          JSON.stringify({ usuario: usuarioParaEnviar }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
  
        toast.current.show({
          severity: "success",
          summary: "¡Listo!",
          detail: response.data.success,
          life: 3000,
        });
  
        GetUsuarios();
        setModulosDialog(false);
        setUsuario(emptyUsuario);
      }
    } catch (error) {
      console.error("Error al actualizar módulos:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudieron guardar los módulos",
        life: 3000,
      });
    }
  };
  const SubmitResetPassword = async () => {
    const SendMail = async (usuario) => {
      try {
        const response = await axios.post(
          "/auth/forgot-password",
          JSON.stringify({ usuario }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          toast.current.show({
            severity: "info",
            summary: "Enviado",
            detail: response.data.mensaje,
            life: 3000,
          });
          GetUsuarios();
        } else {
          toast.current.show({
            severity: "danger",
            summary: "Error",
            detail: "Ocurrio un error al eliminar el usuario",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al enviar el correo:", error.message);
      }
    };
    confirmDialog({
      message:
        "Esta seguro que desea restaurar la contraseña del usuario " +
        usuario.email +
        "?",
      header: "Restaurar contraseña",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-info",
      accept: () => SendMail(usuario),
      reject,
    });
  };

  const openEditUsuarioDialog = async (product) => {
    setUsuario({ ...product });
    setEditUsuarioDialog(true);
  };

  const openModulosDialog1 = async (product) => {
    setUsuario({ ...product });
    setModulosDialog(true);
  };
  const openModulosDialog = (usuarioSeleccionado) => {
    const usuarioCopia = {
      ...usuarioSeleccionado,
      Modulos:
        usuarioSeleccionado.Modulos?.map((modulo) => ({
          ...modulo,
          Empresas:
            modulo.Empresas?.map((empresa) => ({
              ...empresa,
              registrosPatronales: Array.isArray(empresa.registrosPatronales)
                ? [...empresa.registrosPatronales]
                : [],
            })) ?? [],
        })) ?? [],
    };

    setUsuario(usuarioCopia);
    setModulosDialog(true);
  };
  const sendUsuario = async (usuario) => {
    const SendMail = async (usuario) => {
      try {
        const response = await axios.post(
          "admin/users/send-credentials",
          JSON.stringify({ usuario }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          toast.current.show({
            severity: "info",
            summary: "Enviado",
            detail: response.data.mensaje,
            life: 3000,
          });
          GetUsuarios();
        } else {
          toast.current.show({
            severity: "danger",
            summary: "Error",
            detail: "Ocurrio un error al eliminar el usuario",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al enviar el correo:", error.message);
      }
    };
    confirmDialog({
      message:
        "Desea enviar la informacion de acceso al usuario al correo " +
        usuario.email +
        " ?",
      header: "Envio de correo",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-info",
      accept: () => SendMail(usuario),
      reject,
    });
  };

  const reject = () => {
    //toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
  };
  const deleteUsuario = (user) => {
    const acceptDelete = async (user) => {
      try {
        const response = await axios.delete("admin/users/delete", {
          data: { id: user._id },
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
        if (response.status === 200) {
          toast.current.show({
            severity: "info",
            summary: "Eliminado",
            detail: "Usuario eliminado",
            life: 3000,
          });
          GetUsuarios();
        } else {
          toast.current.show({
            severity: "danger",
            summary: "Error",
            detail: "Ocurrio un error al eliminar el usuario",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al eliminar el usuario:", error.message);
      }
    };
    confirmDialog({
      message:
        "Esta seguro que desea eliminar al usuario " + user.nombre + " ?",
      header: "Confirmar eliminacion",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept: () => acceptDelete(user),
      reject,
    });
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _product = { ...usuario };

    _product[`${name}`] = val;

    setUsuario(_product);
  };

  const buttonsTableTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-plus"
          rounded
          outlined
          className="mr-2"
          onClick={() => openModulosDialog(rowData)}
          tooltip="Agregar modulo"
        />
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          className="mr-2"
          onClick={() => openEditUsuarioDialog(rowData)}
          tooltip="Editar usuario"
        />
        <Button
          icon="pi pi-envelope"
          rounded
          outlined
          className="mr-2"
          onClick={() => sendUsuario(rowData)}
          tooltip="Enviar credenciales"
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          className="mr-2 "
          onClick={() => deleteUsuario(rowData)}
          tooltip="Eliminar usuario"
        />
      </React.Fragment>
    );
  };

  const newUserDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        outlined
        onClick={hideDialog}
      />
      <Button label="Guardar" icon="pi pi-check" onClick={saveUsuario} />
    </React.Fragment>
  );
  const generatePassword = (length = 12) => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let result = "";
    for (let i = 0; i < length; i++) {
      const index = Math.floor(Math.random() * charset.length);
      result += charset[index];
    }
    return result;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuario((prev) => ({ ...prev, [name]: value }));
  };

  const handleGeneratePassword = () => {
    const newPassword = generatePassword(8);
    setUsuario((prev) => ({ ...prev, password: newPassword }));
  };
  const handleEmpresaChange = (moduloIndex, empresaIndex, e) => {
    const { name, value } = e.target;
    setUsuario((prev) => {
      const nuevosModulos = [...prev.Modulos];
      nuevosModulos[moduloIndex].Empresas[empresaIndex][name] = value;
      return { ...prev, Modulos: nuevosModulos };
    });
  };
  const eliminarEmpresa = (index) => {
    setUsuario((prev) => {
      const nuevosModulos = [...prev.Modulos];
      const nuevasEmpresas = [...nuevosModulos[0].Empresas];
      nuevasEmpresas.splice(index, 1);

      nuevosModulos[0] = {
        ...nuevosModulos[0],
        Empresas: nuevasEmpresas,
      };

      return {
        ...prev,
        Modulos: nuevosModulos,
      };
    });
  };
  const agregarEmpresa = () => {
    setUsuario((prev) => {
      const nuevosModulos = [...prev.Modulos];
      const empresasActuales = nuevosModulos[0].Empresas || [];

      nuevosModulos[0] = {
        ...nuevosModulos[0],
        Empresas: [
          ...empresasActuales,
          {
            rfc: "",
            nombre: "",
            registrosPatronales: [{ registroPatronal: "", nombre: "" }],
          },
        ],
      };

      return {
        ...prev,
        Modulos: nuevosModulos,
      };
    });
  };

  const handleRegistroPatronalChange = (
    moduloIndex,
    empresaIndex,
    registroIndex,
    e
  ) => {
    const { name, value } = e.target;

    setUsuario((prev) => {
      const nuevosModulos = [...prev.Modulos];
      const empresa = nuevosModulos[moduloIndex].Empresas[empresaIndex];

      const nuevosRegistros = empresa.registrosPatronales.map((registro, idx) =>
        idx === registroIndex ? { ...registro, [name]: value } : registro
      );

      empresa.registrosPatronales = nuevosRegistros;

      nuevosModulos[moduloIndex].Empresas[empresaIndex] = { ...empresa };

      return { ...prev, Modulos: nuevosModulos };
    });
  };
  const agregarRegistroPatronal = (empresaIndex) => {
    setUsuario((prev) => {
      const nuevosModulos = [...prev.Modulos];
      const empresas = [...nuevosModulos[0].Empresas];
      const empresa = { ...empresas[empresaIndex] };

      // ✅ Corrige aquí asegurando que registrosPatronales es un array
      const nuevosRegistros = Array.isArray(empresa.registrosPatronales)
        ? [...empresa.registrosPatronales]
        : [];
      console.log("Registros antes de agregar:", nuevosRegistros); // 👈 revisa esto
      nuevosRegistros.push({ registroPatronal: "", nombre: "" });

      empresa.registrosPatronales = nuevosRegistros;
      empresas[empresaIndex] = empresa;
      nuevosModulos[0].Empresas = empresas;

      return {
        ...prev,
        Modulos: nuevosModulos,
      };
    });
  };

  const eliminarRegistroPatronal = (empresaIndex, refIndex) => {
    setUsuario((prev) => {
      const nuevosModulos = [...prev.Modulos];
      const empresas = [...nuevosModulos[0].Empresas];
      const empresa = { ...empresas[empresaIndex] };
      const registros = [...empresa.registrosPatronales];

      registros.splice(refIndex, 1);
      empresa.registrosPatronales = registros;
      empresas[empresaIndex] = empresa;
      nuevosModulos[0].Empresas = empresas;

      console.log("Registros después de eliminar:", registros); // 👈 revisa esto
      console.log("Empresas después de eliminar:", emptyUsuario); // 👈 revisa esto
      return {
        ...prev,
        Modulos: nuevosModulos,
      };
    });
  };
  const [rolesSeleccionados, setRolesSeleccionados] = useState([]);
  const ROLES = {
    User: 2001,
    Editor: 1984,
    Admin: 5150,
  };
  const onRoleChange = (e, roleKey, roleValue) => {
    const newRoles = { ...usuario.roles };

    if (e.checked) {
      newRoles[roleKey] = roleValue;
    } else {
      delete newRoles[roleKey];
    }

    setUsuario({ ...usuario, roles: newRoles });
  };

  const handleNominasChange = (moduloIndex, value) => {
    const updatedUsuario = { ...usuario };
    updatedUsuario.Modulos[moduloIndex].Nominas = value;
    setUsuario(updatedUsuario);
  };
  const handleC4NombreChange = (moduloIndex, value) => {
    const updatedUsuario = { ...usuario };
    updatedUsuario.Modulos[moduloIndex].NombreCliente = value;
    setUsuario(updatedUsuario);
  };
  const handleC4RUCChange = (moduloIndex, value) => {
    const updatedUsuario = { ...usuario };
    updatedUsuario.Modulos[moduloIndex].RUC = value;
    setUsuario(updatedUsuario);
  };
  const handleC4RegimenChange = (moduloIndex, value) => {
    const updatedUsuario = { ...usuario };
    updatedUsuario.Modulos[moduloIndex].Regimen = value;
    setUsuario(updatedUsuario);
  };
  const toggleModulo = (moduloNombre) => {
    setUsuario((prevUsuario) => {
      const yaExiste = prevUsuario.Modulos.some(
        (m) => m.nombre === moduloNombre
      );

      if (yaExiste) {
        return {
          ...prevUsuario,
          Modulos: prevUsuario.Modulos.filter((m) => m.nombre !== moduloNombre),
        };
      } else {
        const nuevoModulo =
          moduloNombre === "SUA"
            ? {
                nombre: "SUA",
                Empresas: [{ rfc: "", nombre: "", registrosPatronales: [] }],
                cntEmpresas: 0,
                cntRegistrosPatronales: 0,
              }
            : { nombre: "NOM", Nominas: "" };

        return {
          ...prevUsuario,
          Modulos: [...prevUsuario.Modulos, nuevoModulo],
        };
      }
    });
  };
  const [activeIndexes, setActiveIndexes] = useState(
    usuario.Modulos.map((m, i) => (m.activo ? i : null)).filter(
      (i) => i !== null
    )
  );
  const handleModuloActivo = (nombreModulo, activo) => {
    setUsuario((prevUsuario) => {
      const modulos = [...prevUsuario.Modulos];
      const index = modulos.findIndex((m) => m.nombre === nombreModulo);
  
      if (index !== -1) {
        modulos[index] = { ...modulos[index], activo };
      } else {
        const nuevo = crearModuloPorTipo(nombreModulo);
        nuevo.activo = activo;
        modulos.push(nuevo);
      }
  
      return { ...prevUsuario, Modulos: modulos };
    });
  };
  
  const renderModuloPorTipo = (modulo, moduloIndex) => {
    if (!modulo.activo) return null;

    switch (modulo.nombre) {
      case "SUA":
        return (
          <>
            {modulo.Empresas.map((empresa, empresaIndex) => (
              <div
                key={empresaIndex}
                className="border-1 p-3 mb-3 border-round"
              >
                <h6>Empresa #{empresaIndex + 1}</h6>
                <div className="grid">
                  <div className="col-6">
                    <label>RFC</label>
                    <InputText
                      name="rfc"
                      value={empresa.rfc}
                      onChange={(e) =>
                        handleEmpresaChange(moduloIndex, empresaIndex, e)
                      }
                    />
                  </div>
                  <div className="col-6">
                    <label>Nombre</label>
                    <InputText
                      name="nombre"
                      value={empresa.nombre}
                      onChange={(e) =>
                        handleEmpresaChange(moduloIndex, empresaIndex, e)
                      }
                    />
                  </div>
                </div>

                {empresa.registrosPatronales.map((reg, regIndex) => (
                  <div key={regIndex} className="grid mt-2">
                    <div className="col-5">
                      <label>Registro patronal</label>
                      <InputText
                        name="registroPatronal"
                        value={reg.registroPatronal}
                        onChange={(e) =>
                          handleRegistroPatronalChange(
                            moduloIndex,
                            empresaIndex,
                            regIndex,
                            e
                          )
                        }
                      />
                    </div>
                    <div className="col-5">
                      <label>Nombre (Alias)</label>
                      <InputText
                        name="nombre"
                        value={reg.nombre}
                        onChange={(e) =>
                          handleRegistroPatronalChange(
                            moduloIndex,
                            empresaIndex,
                            regIndex,
                            e
                          )
                        }
                      />
                    </div>
                    <div className="col-2 flex align-items-end">
                      <Button
                        icon="pi pi-trash"
                        severity="danger"
                        onClick={() =>
                          eliminarRegistroPatronal(
                            moduloIndex,
                            empresaIndex,
                            regIndex
                          )
                        }
                      />
                    </div>
                  </div>
                ))}

                <Button
                  className="mt-2"
                  icon="pi pi-plus"
                  label="Agregar registro patronal"
                  onClick={() =>
                    agregarRegistroPatronal(moduloIndex, empresaIndex)
                  }
                />

                <Button
                  className="mt-2 ml-2"
                  icon="pi pi-trash"
                  label="Eliminar empresa"
                  severity="danger"
                  onClick={() => eliminarEmpresa(moduloIndex, empresaIndex)}
                  disabled={modulo.Empresas.length === 1}
                />
              </div>
            ))}

            <Button
              icon="pi pi-plus"
              label="Agregar empresa"
              className="mt-2"
              onClick={() => agregarEmpresa(moduloIndex)}
            />
          </>
        );

      case "NOM":
        return (
          <div className="mt-2">
            <label>Nominas</label>
            <InputText
              value={modulo.Nominas}
              onChange={(e) => handleNominasChange(moduloIndex, e.target.value)}
            />
          </div>
        );

      case "CFDI":
        return (
          <div className="mt-2">
            <label>Emisores (pendiente)</label>
          </div>
        );

      case "IMSS":
        return (
          <div className="mt-2">
            <label>Archivos IMSS (pendiente)</label>
          </div>
        );
      case "C4-Nic":
        return (
          <>
          <div className="mt-2">
            <label>Nombre</label>
            <InputText
              value={modulo.NombreCliente}
              onChange={(e) => handleC4NombreChange(moduloIndex, e.target.value)}
            />
          </div>
          <div className="mt-2">
            <label>RUC</label>
            <InputText
              value={modulo.RUC}
              onChange={(e) => handleC4RUCChange(moduloIndex, e.target.value)}
            />
          </div>
          <div className="mt-2">
            <label>Regimen</label>
            <InputText
              value={modulo.Regimen}
              onChange={(e) => handleC4RegimenChange(moduloIndex, e.target.value)}
            />
          </div>
          </>
        );

      default:
        return <p>Módulo sin definición: {modulo.nombre}</p>;
    }
  };
  const MODULOS_DISPONIBLES = ["SUA", "NOM", "XCS", "IMSS", "C4-Nic"];
  const prepararModulosUsuario = (usuarioModulos) => {
    return MODULOS_DISPONIBLES.map((nombre) => {
      const existente = usuarioModulos.find((m) => m.nombre === nombre);
      return existente
        ? { ...crearModuloPorTipo(nombre), ...existente }
        : crearModuloPorTipo(nombre);
    });
  };
  useEffect(() => {
    setUsuario((prevUsuario) => {
      const modulosActuales = prevUsuario.Modulos || [];

      const modulosCompletos = MODULOS_DISPONIBLES.map((nombre) => {
        const existente = modulosActuales.find((m) => m.nombre === nombre);
        return existente ?? { ...crearModuloPorTipo(nombre), activo: false };
      });

      return { ...prevUsuario, Modulos: modulosCompletos };
    });
  }, []);
  return (
    <div>
      {/* <FormularioUsuario /> */}
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="card">
        <Toolbar
          className="mb-4"
          start={
            <div className="flex flex-wrap gap-2">
              <Button
                label="Nuevo usuario"
                icon="pi pi-plus"
                severity="success"
                onClick={openNew}
              />
            </div>
          }
          end={
            <Button
              label="Export"
              icon="pi pi-upload"
              className="p-button-help"
              onClick={exportCSV}
            />
          }
        ></Toolbar>

        <DataTable
          ref={dt}
          value={usuarios}
          selection={selectedEmpresas}
          onSelectionChange={(e) => setSelectedEmpresas(e.value)}
          dataKey="_id"
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
          globalFilter={globalFilter}
          header={
            <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
              <h4 className="m-0"> </h4>
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText
                  type="search"
                  onInput={(e) => setGlobalFilter(e.target.value)}
                  placeholder="Busqueda..."
                />
              </IconField>
            </div>
          }
        >
          <Column selectionMode="multiple" exportable={false}></Column>
          <Column
            field="nombre"
            header="Nombre"
            sortable
            style={{ minWidth: "12rem" }}
          ></Column>
          <Column
            field="email"
            header="Email"
            sortable
            style={{ minWidth: "16rem" }}
          ></Column>
          <Column
            body={buttonsTableTemplate}
            exportable={false}
            style={{ minWidth: "12rem" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={newUsuarioDialog}
        style={{ width: "60vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Nuevo usuario"
        modal
        className="p-fluid"
        footer={newUserDialogFooter}
        onHide={hideDialog}
      >
        <div className="grid gap-4">
          <div className="col-4">
            <label htmlFor="nombre" className="font-bold">
              Nombre
            </label>
            <InputText
              id="nombre"
              value={usuario.nombre}
              onChange={(e) => onInputChange(e, "nombre")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !usuario.nombre,
              })}
            />
          </div>
          <div className="col-7">
            <label htmlFor="email" className="font-bold">
              Email
            </label>
            <InputText
              id="email"
              value={usuario.email}
              onChange={(e) => onInputChange(e, "email")}
              required
            />
          </div>
          <div className="col-4">
            <label htmlFor="password" className="font-bold">
              Password
            </label>
            <div className="flex align-items-center gap-2">
              <Password
                id="password"
                name="password"
                value={usuario.password}
                onChange={handleChange}
                toggleMask
                feedback={false}
                className="flex-1"
              />
              <Button
                icon="pi pi-refresh"
                type="button"
                onClick={handleGeneratePassword}
                tooltip="Generar contraseña"
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="roles" className="font-bold">
              Roles
            </label>
            <div className="card flex justify-content-center">
              <div className="flex flex-wrap gap-3">
                {Object.entries(ROLES).map(([key, value]) => (
                  <div key={value} className="flex align-items-center">
                    <Checkbox
                      inputId={`rol-${key}`}
                      name="rol"
                      value={value}
                      onChange={(e) => onRoleChange(e, key, value)}
                      checked={usuario.roles.hasOwnProperty(key)}
                    />
                    <label htmlFor={`rol-${key}`} className="ml-2">
                      {key}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="grid gap-4 mt-4">
          {usuario.Empresas.map((empresa, index) => (
            <div
              key={index}
              className="col-12 border-1 border-300 p-3 border-round"
            >
              <h5 className="m-0 mb-3">Empresa #{index + 1}</h5>

              <div className="grid gap-3">
                <div className="col-12 md:col-4">
                  <label className="block mb-1">RFC</label>
                  <InputText
                    name="rfc"
                    value={empresa.rfc}
                    onChange={(e) => handleDireccionChange(index, e)}
                  />
                </div>
                <div className="col-12 md:col-8">
                  <label className="block mb-1">Nombre</label>
                  <InputText
                    name="nombre"
                    value={empresa.nombre}
                    onChange={(e) => handleDireccionChange(index, e)}
                  />
                </div>
              </div>
              {empresa.registrosPatronales?.map((ref, refIndex) => (
                <div key={refIndex} className="grid gap-3 mt-2">
                  <div className="col-1 justify-content-center flex align-items-end">
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      severity="danger"
                      label=""
                      onClick={() => eliminarReferencia(index, refIndex)}
                    />
                  </div>
                  <div className="col-3">
                    <label className="block mb-1">Registro patronal</label>
                    <InputText
                      name="registroPatronal"
                      value={ref.registroPatronal}
                      onChange={(e) =>
                        handleReferenciaChange(index, refIndex, e)
                      }
                    />
                  </div>

                  <div className="col-7">
                    <label className="block mb-1">Nombre(Alias)</label>
                    <InputText
                      name="nombre"
                      value={ref.nombre}
                      onChange={(e) =>
                        handleReferenciaChange(index, refIndex, e)
                      }
                    />
                  </div>
                </div>
              ))}
              <div className="mt-2 col-offset-9 col-3">
                <Button
                  type="button"
                  icon="pi pi-plus"
                  label="Registro patronal"
                  onClick={() => agregarReferencia(index)}
                  className="mb -3 col-12"
                />
              </div>
              <div className="m t-2 col-offset-9 col-3">
                <Button
                  type="button"
                  icon="pi pi-trash"
                  severity="danger"
                  label="Eliminar empresa"
                  className="m l-2 mb -3 col-12"
                  onClick={() => eliminarDireccion(index)}
                  disabled={usuario.Empresas.length === 1}
                />
              </div>
              <div></div>
            </div>
          ))}
          <div className="col-offset-4 col-4">
            <Button
              type="button"
              icon="pi pi-plus"
              label="Agregar empresa"
              onClick={agregarDireccion}
            />
          </div>
        </div> */}
      </Dialog>

      <Dialog
        visible={editUsuarioDialog}
        style={{ width: "40rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Editar usuario"
        modal
        className="p-fluid"
        footer={
          <React.Fragment>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              outlined
              onClick={hideDialogEdit}
            />
            <Button
              label="Contraseña"
              icon="pi pi-refresh"
              onClick={SubmitResetPassword}
              tooltip="Resetear contraseña"
            />
            <Button
              label="Editar"
              icon="pi pi-save"
              onClick={SubmitEditUsuario}
              tooltip="Guardar usuario"
            />
          </React.Fragment>
        }
        onHide={hideDialogEdit}
      >
        <div className="field">
          <label htmlFor="nombre" className="font-bold">
            Nombre
          </label>
          <InputText
            id="nombre"
            value={usuario.nombre}
            onChange={(e) => onInputChange(e, "nombre")}
            autoFocus
          />
        </div>
        <div className="field">
          <label htmlFor="RFC" className="font-bold">
            Email
          </label>
          <InputText
            id="RFC"
            value={usuario.email}
            onChange={(e) => onInputChange(e, "email")}
            required
          />
        </div>
        <div className="field">
          <label htmlFor="roles" className="font-bold">
            Roles
          </label>
          <div className="card flex justify-content-center">
            <div className="flex flex-wrap gap-3">
              {Object.entries(ROLES).map(([key, value]) => (
                <div key={value} className="flex align-items-center">
                  <Checkbox
                    inputId={`rol-${key}`}
                    name="rol"
                    value={value}
                    onChange={(e) => onRoleChange(e, key, value)}
                    checked={usuario.roles.hasOwnProperty(key)}
                  />
                  <label htmlFor={`rol-${key}`} className="ml-2">
                    {key}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={modulosDialog}
        style={{ width: "60rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Agregar Modulos"
        modal
        className="p-fluid"
        footer={
          <React.Fragment>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              outlined
              onClick={hideDialogModulos}
            />
            <Button
              label="Editar"
              icon="pi pi-save"
              onClick={SubmitModulosUsuario}
              tooltip="Guardar usuario"
            />
          </React.Fragment>
        }
        onHide={hideDialogModulos}
      >
        <div className="mb-3">
          <label className="block mb-2">
            Selecciona los módulos a configurar:
          </label>
          <div className="flex flex-column gap-2">
  {MODULOS_DISPONIBLES.map((mod) => {
    const moduloUsuario = usuario.Modulos.find((m) => m.nombre === mod);
    const activo = moduloUsuario?.activo || false;

    return (
      <div key={mod} className="flex align-items-center">
        <Checkbox
          inputId={mod}
          value={mod}
          checked={activo}
          onChange={(e) => handleModuloActivo(mod, e.checked)}
        />
        <label htmlFor={mod} className="ml-2">{mod}</label>
      </div>
    );
  })}
</div>

        </div>

        <Accordion multiple activeIndex={[0]}>
          {usuario.Modulos.map((modulo, moduloIndex) => (
            <AccordionTab
              key={moduloIndex}
              header={`Módulo: ${modulo.nombre}`}
              disabled={!modulo.activo}
            >
              {renderModuloPorTipo(modulo, moduloIndex)}
            </AccordionTab>
          ))}
        </Accordion>
      </Dialog>
    </div>
  );
}

const Users = () => {
  return (
    <>
      <h2>Gestión de Usuarios</h2>
      <TablaUsuarios />
    </>
  );
};
export default Users;
